import { useState } from "react";
import FinanceTablesContainer from "../../containers/Tables/FinanceTablesContainer";
import DatePicker from "../../components/DatePicker";

const tabData = [
  {
    title: "Servicios",
    optionName: "service",
  },
  {
    title: "Productos",
    optionName: "product",
  },
  {
    title: "Arriendos",
    optionName: "rent",
  },
  {
    title: "Banco",
    optionName: "bank",
  },
  {
    title: "Otros",
    optionName: "other",
  },
];

const IngresosPage = () => {
  const nowDate = new Date();
  const [dateValues, setDateValues] = useState({
    year: nowDate.getFullYear(),
    month: nowDate.getMonth() + 1,
  });
  const [tipoIngreso, setTipoIngreso] = useState(tabData[0]);
  return (
    <div className="content">
      <div className="subfinanzas-header">
        <div className="d-flex align-items-center gap-4">
          <h1>Finanzas - Ingresos</h1>
          <DatePicker dateValues={dateValues} setDateValues={setDateValues} />
        </div>
        <div className="subfinanzas-header-tabs">
          <ul className="nav nav-tabs">
            {tabData.map((tab) => (
              <li
                className="nav-item"
                key={tab.optionName}
                onClick={() => setTipoIngreso(tab)}
              >
                <span
                  className={
                    "nav-link " +
                    (tipoIngreso.optionName === tab.optionName ? "active" : "")
                  }
                >
                  {tab.title}
                </span>
              </li>
            ))}
          </ul>
        </div>
      </div>
      <div className="subfinanzas-content">
        <FinanceTablesContainer
          dateValues={dateValues}
          activeType={tipoIngreso}
          transactionType="ingreso"
        />
      </div>
    </div>
  );
};

export default IngresosPage;
